import React from "react";
import googleIcon from "../../assets/google-color-icon.webp";
import logo from "../../assets/logo_white.png";
import { useAuth } from "@/hooks/useAuth";

export const Login: React.FC = () => {
  const { user, login, isLoading } = useAuth();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#1a1a1a] p-5">
      <img src={logo} alt="SpreadFighter Logo" className="w-[400px] mb-10" />
      <button
        onClick={login}
        className="flex items-center gap-2.5 px-6 py-3 bg-[#202124] hover:bg-[#303134] text-white rounded text-base transition-colors duration-200 cursor-pointer border border-[#5f6368]"
      >
        <img src={googleIcon} alt="Google Icon" className="w-6 h-6" />
        Sign in with Google
      </button>
      <p className="text-sm text-[#5f6368] mt-5">
        By signing in, you agree to the{" "}
        <a
          target="_blank"
          href="https://spreadfighter.com/terms#!/tab/672420695-3"
          className="text-white"
          rel="noreferrer"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          target="_blank"
          href="https://spreadfighter.com/terms#!/tab/672420695-4"
          className="text-white"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        <br />
        <span className="text-[#5f6368]">
          You can unsubscribe from any email notification later in you profile
        </span>
      </p>
    </div>
  );
};
